import { render, staticRenderFns } from "./zswiper.vue?vue&type=template&id=36277cca"
import script from "./zswiper.vue?vue&type=script&lang=js"
export * from "./zswiper.vue?vue&type=script&lang=js"
import style0 from "./zswiper.vue?vue&type=style&index=0&id=36277cca&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36277cca')) {
      api.createRecord('36277cca', component.options)
    } else {
      api.reload('36277cca', component.options)
    }
    module.hot.accept("./zswiper.vue?vue&type=template&id=36277cca", function () {
      api.rerender('36277cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/components/zswiper.vue"
export default component.exports